export const isAttendeesPage = () => {
  const pathname =
    typeof window !== "undefined" ? window.location.pathname : "";

  if (!pathname) return false;

  // check if registration page
  if (/\/registration$/.test(pathname)) return true;

  // check if content hub lead page
  if (/\/page\/(?!create$)[a-zA-Z0-9-]+$/.test(pathname)) return true;

  return false;
};
